export default {
  /**
   * 获取 URL 中的参数
   * @param {String} name   取哪个字段
   * @returns {string|null}
   */
  getUrlKey(name) {
    return decodeURIComponent((new RegExp('[?|&]' + name + '=' + '([^&;]+?)(&|#|;|$)').exec(location.href) || [undefined, ""])[1].replace(/\+/g, '%20')) || null
  },

  // 获得apikey
  getApiKey() {
    return process.env.VUE_APP_API_KEY || 'b4319770e45adacef4755abe2ea27a39';
  },

  // 获得环境
  getEnv() {
    return process.env.VUE_APP_ENV || 'dev';
  }
}